module.exports = __webpack_public_path__ + "img/arrow-up.b24548c9.svg";